/**
 * @generated SignedSource<<7e8a97d3277dec8d7966df3f6932bcb7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductInternalTools_itemSearch$data = {
  readonly pageType: string | null;
  readonly " $fragmentType": "ProductInternalTools_itemSearch";
};
export type ProductInternalTools_itemSearch$key = {
  readonly " $data"?: ProductInternalTools_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductInternalTools_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductInternalTools_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "a6a77006e98af5c646d18aee7cac3b26";

export default node;
